import { all } from 'redux-saga/effects';
import sweepsSaga from './sweeps/sagas';
import photosSaga from './photos/sagas';
import videosSaga from './videos/sagas';
import usersSaga from './users/sagas';
import itemsObservations from './itemsObservations/sagas'
import authenticationSaga from './authentication/sagas';
import itemsNames from './itemsNames/sagas';


const rootSaga = all([
    sweepsSaga,
    authenticationSaga,
    photosSaga,
    videosSaga,
    usersSaga,
    itemsObservations,
    itemsNames,
])

export default function* rootsaga() {
    yield rootSaga
};